// extracted by mini-css-extract-plugin
module.exports = {"manual-table":"discountTable_manual-table__1K2HQ","read-only":"discountTable_read-only__YxvPv","thead":"discountTable_thead__2sHna","optional":"discountTable_optional__3hPXb"};